import React from 'react';
import { useAuth } from '../context/AuthContext';

const TopBar = ({ currentPage }) => {
  const { user, logout } = useAuth();

  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="topbar-breadcrumb">
          <span>AdventureWorks Analytics</span>
          <span className="topbar-breadcrumb-sep">/</span>
          <span className="topbar-breadcrumb-page">{currentPage?.label || 'Dashboard'}</span>
        </div>
      </div>

      <div className="topbar-right">
        <div className="topbar-actions">
          <button className="topbar-action-btn" title="Refresh Report">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 4 23 10 17 10" />
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </svg>
          </button>
          <button className="topbar-action-btn" title="Full Screen">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
          </button>
          <button className="topbar-action-btn" title="Export">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </button>
        </div>

        <div className="topbar-divider" />

        <div className="topbar-user">
          <div className="topbar-avatar">{user?.avatar || 'U'}</div>
          <div className="topbar-user-info">
            <span className="topbar-user-name">{user?.name || 'User'}</span>
            <span className="topbar-user-role">{user?.role || 'Viewer'}</span>
          </div>
        </div>

        <button className="topbar-logout-btn" onClick={logout}>Sign Out</button>
      </div>
    </header>
  );
};

export default TopBar;
